var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    rx: 14,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 52L42 90.5L124.5 15L20 52Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 90.5L91.5 53.5L72.5 145L57.5 90.5Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 132.5L104.5 40L119.5 88L84.5 132.5Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 119.5L96 128L120.5 142L103 119.5Z",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 156,
    rx: 14,
    fill: "#8D19DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51.816L125 15L42.361 90L20 51.816Z",
    fill: "url(#paint0_linear_1490_454)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 90.2017L92 53L72.923 145L58 90.2017Z",
    fill: "url(#paint1_linear_1490_454)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1264 145L71 94.9455L92 53L73.1264 145Z",
    fill: "url(#paint2_linear_1490_454)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120 87.6403L105.014 40L85 132L120 87.6403Z",
    fill: "url(#paint3_linear_1490_454)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85 132L107 86.9101L105.118 40L85 132Z",
    fill: "url(#paint4_linear_1490_454)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90L44.5443 63.9202L125 15L42 90Z",
    fill: "url(#paint5_linear_1490_454)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.376 119L121 142L96 127.782L103.376 119Z",
    fill: "url(#paint6_linear_1490_454)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96 128.489L102.517 127L121 142L96 128.489Z",
    fill: "url(#paint7_linear_1490_454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1490_454",
    x1: 31.2077,
    y1: 70.9025,
    x2: 114.622,
    y2: 40.2849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CB32ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1490_454",
    x1: 67.5663,
    y1: 111.044,
    x2: 82.117,
    y2: 63.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CB32ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1490_454",
    x1: 79.5829,
    y1: 92.4053,
    x2: 69.7344,
    y2: 129.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CB32ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1490_454",
    x1: 105.356,
    y1: 94.8992,
    x2: 113.624,
    y2: 60.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1490_454",
    x1: 99.2581,
    y1: 66.376,
    x2: 95.5798,
    y2: 113.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1490_454",
    x1: 90.7233,
    y1: 48.8392,
    x2: 41.6715,
    y2: 73.5501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CB32ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1490_454",
    x1: 98.252,
    y1: 128.871,
    x2: 123.102,
    y2: 131.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1490_454",
    x1: 105.671,
    y1: 128.701,
    x2: 112.52,
    y2: 145.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3615C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader3);
export default __webpack_public_path__ + "static/media/loader3.c357c9229a29dd2780f051fc8d8bc286.svg";
export { ForwardRef as ReactComponent };